angular.module('dnecom')
   .directive('simpleBar', ["$parse", function($parse) {
        return {
            restrict: "EA",
            scope: {
                max: '=max',
                current: '=current',
                barForegroundClass: '@',
                barBackgroundClass: '@',
                barRight: '=?'
            },
            transclude: true,
            link: function (scope, element, attrs) {
                scope.barWidth = Math.round(scope.current / scope.max * 100);
            },
            template: '    <div class="pull-left" style="width: 40px;">\n        {{ barWidth }}%\n    </div>\n    <div class="pull-left" style="width: calc(100% - 40px); width: -webkit-calc(100% - 45px;)"> \n        <div class="progress m-b-0 m-t-4 progress-large {{ barBackgroundClass }}" ng-class="{\'pull-right\' : barRight}">\n            <div class="progress-bar {{ barForegroundClass }}" style="width:{{ barWidth }}%;"></div>\n        </div>\n    </div>'
        };
    }])
;
